import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';
import Select from 'react-select';
import axiosInstance from '../utils/axiosInstance';
import './previousClients.css';

function PreviousClients ( {authenticatedUser, isLoading, setAdmin} ) {
    const navigate = useNavigate();

    /*const getInitialAreaState = () => {
        const value = "";
        return value;
    };*/

    const getInitialSortByState = () => {
        const value = {value: "Total Refund", label: "Total Refund"};
        return value;
    };
    const getInitialSortDirState = () => {
        const value = {value: "DESC", label: "DESC"};
        return value;
    };
    const getInitialClientStatus = () => {
        const value = {value: "", label: "ALL CLIENTS"};
        return value;
    };

    const [mktReport, setMktReport] = useState([]);
    const [gettingResults, setGettingResults] = useState(true);

    const [options, setOptions] = useState([{value: "", label: "ALL CLIENTS"}, {value: "Current Client", label: "CURRENT CLIENTS"}, {value: "Past Client", label: "PAST CLIENTS"}])
    const [clientStatus, setClientStatus] = useState(getInitialClientStatus)

    const columnNames = [{value: "Total Refund", label: "Total Refund"}, {value: "HC Expiring", label: "HC Expiring"}, {value: "HighCost", label: "HighCost"}, {value: "LowPro", label: "LowPro"}, {value: "A-Z", label: "A-Z"}, {value: "New Drills", label: "New Drills"}, {value: "Client Status", label: "Client Status"}];
    const [sortBy, setSortBy] = useState(getInitialSortByState);

    const sortOpt = [{value: "ASC", label: "ASC"}, {value: "DESC", label: "DESC"}];
    const [sortDir, setSortDir] = useState(getInitialSortDirState);
    
    const customStyles = {
        control: (provided) => ({
            ...provided,
            display: 'inline-flex', // or 'inline-flex'
            width: 'auto', // Adjust as needed
            marginRight: '10px',
        }),
        option: (base) => ({ ...base, color: 'black' }),
        menu: (provided) => ({
            ...provided,
            width: 'max-content',
            minWidth: '100%',
          }),
    };

    useEffect(() => { 
        getClients();
        setGettingResults(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        if (authenticatedUser === null) {
            return;
        } 

        if(authenticatedUser === false){
            //console.log('authenticatedUser is null sending to login page')
            navigate("/login");
        }

        const getAdminState = async() => {
        await axiosInstance.get('/checkAdmin', {withCredentials:true} )
        .then(response => {
            setAdmin(response.data.isAdmin)
        })
        .catch(error => {
            setAdmin(false)
            console.log(error)
        });
        };
    
        getAdminState();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticatedUser]);

    const getClients = async() => {
        setGettingResults(true);
        await axiosInstance.get('/getClients', {withCredentials:true})
        .then(response => {
            setMktReport(response.data[0]);
            setGettingResults(false);
        })
        .catch(error => console.error('Error fetching refunds:', error));
    };

    const exportToExcel = () => {
        const mktReportOut = mktReport.map( ({ LowPro, HighCost, TwoYrInactive, RefundExpiring, Refund, ...rest }) => 
            ({ ...rest}) );

        var ws = XLSX.utils.json_to_sheet(mktReportOut);
        /* create workbook and export */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, "ClientMarketingReport.xlsx");
    };

    const clickMe = (data) => {
        navigate("/taxpayer", { state: {data: data} });
    }

    const getTaxpayer = async() => {
        setGettingResults(true);
        await axiosInstance.post('/searchClients', {data: {clientStatus: clientStatus.value, sortBy: sortBy.value, sortDir: sortDir.value}}, {withCredentials:true})
        .then(response => {
            setMktReport(response.data[0]);
            setGettingResults(false);
        })
        .catch(error => console.error('Error fetching refunds:', error));
    };

    const handleSortByDropDownChange = (selectedSortBy) => {
        setSortBy(selectedSortBy)
    };

    const handleSortDirDropDownChange = (selectedSortDir) => {
        setSortDir(selectedSortDir)
    }

    const handleClientSelectDropDownChange = (selectedClientStatus) => {
        setClientStatus(selectedClientStatus)
    }

    const clearSearch = async() => {
        setGettingResults(true);
        setSortBy(getInitialSortByState);
        await axiosInstance.get('/getRefunds', {withCredentials:true})
        .then(response => {
            setMktReport(response.data[0]);
            setGettingResults(false);
        })
        .catch(error => console.error('Error fetching refunds:', error));
    };

    if(gettingResults){
        return <div className="search-app"> <h1>Loading Client Page...</h1> </div>
    }
    
    return (
        <div className="search-app">
                
            <h1>Marketing Report</h1>
            <p>Disclaimer: All information contained herein is proprietary to T-COT and is provided solely for the purpose of obtaining a contract with T-COT. Unauthorized use, disclosure, or distribution of this information is strictly prohibited. Any other use of this information without the express written consent of T-COT is not permitted.</p>


            <div className="taxpayer-input">
                <button onClick={exportToExcel}>Export to Excel</button>

                <p>Filter By:</p>

                <Select
                    className="client-select"
                    isClearable={false}
                    styles={customStyles}
                    onChange={handleClientSelectDropDownChange}
                    defaultValue={options[0]}
                    value={clientStatus}
                    options={options} 
                /> 

                <p>Sort By: </p>

                <Select
                    className="sort-select"
                    isClearable={false}
                    styles={customStyles}
                    onChange={handleSortByDropDownChange}
                    defaultValue={columnNames[0]}
                    value={sortBy}
                    options={columnNames} 
                />

                <Select
                    className="order-select"
                    isClearable={false}
                    styles={customStyles}
                    onChange={handleSortDirDropDownChange}
                    defaultValue={sortOpt[1]}
                    value={sortDir}
                    options={sortOpt} 
                /> 
                
                <button onClick={getTaxpayer}>Search</button>
                
                <button onClick={clearSearch} className="clearSearch">Clear Search</button>

            </div>
            
            {mktReport.length === 0 && <h1>No Results Found</h1>}
            
            {mktReport.length > 0 && 
            <table className="totalRefund-table">
                <tbody>
                    <tr>
                        <th width="650.48px">TaxpayerName</th>
                        <th>ClientStatus</th>
                        <th width="150.17px">Area</th>
                        <th width="122.34px">LowPro</th>
                        <th width="122.34px">High Cost</th>
                        <th width="122.34px">HC Expiring</th>
                        <th width="122.34px">Two Year Inactive</th>
                        <th width="122.34px">Total Refund</th>
                        <th width="122.34px">New Drills</th>
                        <th>Expiration Date</th>
                    </tr>
                    
                    {mktReport.map((refundForTP, i) => (
                        <tr height="58px" key={i}>
                            <td>
                                <button onClick={() => clickMe({TPNumber: refundForTP.TaxpayerNumber})} className="ViewDetailsBtnLink">{refundForTP.TaxpayerName}</button>
                                {/*{refundForTP.TaxpayerName}*/}
                            </td>
                            <td>
                                {refundForTP.ClientStatus}
                            </td>
                            <td>
                                {refundForTP.Area}
                            </td>
                            <td>
                                {refundForTP.LowPro}
                            </td>
                            <td>
                                {refundForTP.HighCost}
                            </td>
                            <td>
                                {refundForTP.RefundExpiring}
                            </td>
                            <td>
                                {refundForTP.TwoYrInactive}
                            </td>
                            <td>
                                {refundForTP.Refund}
                            </td>
                            <td>
                                {refundForTP.NewWellsDrilled}
                            </td>
                            <td>
                                {refundForTP.ExpirationDate}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>}

        </div>
    );
};
 
export default PreviousClients;